/** Message type sent by the iFrame to inform about the confirmation of the password */

export const AuthConfirmMessageType = 'AuthConfirm';
